import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getStoreObj, getPaymentMethod, getDeliveryMethod } from "../../utils/storage";
import "../../styles/OrderSubmitPage.css";
import StoreInfo from "../StoreInfo";
import SelectComponent from "./SelectComponent";
import { getCart } from "../../api/cartAPI";
import { checkProductAvailability, getProductById } from "../../api/productsAPI";
import { submitOrder, updProductStatus } from "../../api/orderAPI";

const OrderSubmitPage = () => {
    const storeObj = getStoreObj();
    const paymentMethod = getPaymentMethod();
    const deliveryMethod = getDeliveryMethod();
    const navigate = useNavigate();
    const [cart, setCart] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [unavailableProducts, setUnavailableProducts] = useState([]);
    const [showUnavailableModal, setShowUnavailableModal] = useState(false);
    const [totalPrice, setTotalPrice] = useState(0);
    const [isTotalPriceLoading, setIsTotalPriceLoading] = useState(true);

    const handleCloseModal = () => setShowUnavailableModal(false);

    const handleSubmit = async () => {
        setLoading(true);
        setError(null);

        try {
            const productIds = cart.map((product) => product.product_id);
            console.log('ORDERSUBMIT PAGE ProductIds:', productIds);
            const result = await checkProductAvailability(productIds);
            if (!result.available) {
                setUnavailableProducts(result.unavailableProducts);
                setShowUnavailableModal(true);
                return;
            }

            if (paymentMethod === "cash") {
                const orderId = await submitOrder({
                    storeId: storeObj.store_id,
                    cart: productIds,
                    totalPrice: totalPrice,
                    paymentMethod: paymentMethod,
                    deliveryMethod: deliveryMethod,
                    paymentStatus: "pending"
                });
                navigate("/order-success", { state: { orderId: orderId } });
            } else if (paymentMethod === "online") {
                await updProductStatus(cart.map((product) => product.product_id), "reserved");
                const orderId = await submitOrder({
                    storeId: storeObj.store_id,
                    cart: productIds,
                    totalPrice: totalPrice,
                    paymentMethod: paymentMethod,
                    deliveryMethod: deliveryMethod,
                    paymentStatus: "paid"
                });
                navigate("/order-success", { state: { orderId: orderId } });
            }
        } catch (error) {
            setError('Виник��а помилка під час перевірки доступності товарів. Спробуйте ще раз.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getCart().then((data) => {
            const productPromises = data.map((item) => getProductById(item));
            Promise.all(productPromises)
                .then((products) => {
                    setCart(products);
                })
                .catch((error) => {
                    console.error("Error fetching products:", error);
                });
        });
    }, [unavailableProducts]);

    useEffect(() => {
        const price = cart.reduce((sum, item) => sum + parseFloat(item.discounted_price), 0);
        setTotalPrice(price);
        setIsTotalPriceLoading(false);
    }, [cart]);

    const setPaymentInfo = () => {
        if (paymentMethod === "cash") {
            return {
                img: "/images/cash_icon.svg",
                h4: "Оплата при отримані",
                p: "В магазині готівкою",
                selectType: paymentMethod,
                selectValue: "cash"
            };
        } else if (paymentMethod === "online") {
            return {
                img: "/images/credit_card_icon.svg",
                h4: "Оплата онлайн",
                p: "Зручно і швидко",
                selectType: paymentMethod,
                selectValue: "online"
            };
        } else {
            return "Не вибрано";
        }
    }

    const setDeliveryInfo = () => {
        if (deliveryMethod === "store-delivery") {
            return {
                img: "/images/delivery_icon.svg",
                h4: "Доставка",
                p: "Привезе кур’єр",
                selectType: deliveryMethod,
                selectValue: "store-delivery"
            };
        } else if (deliveryMethod === "pickup") {
            return {
                img: "/images/pickup_icon.svg",
                h4: "Самовивіз",
                p: "Забирайте в магазині",
                selectType: deliveryMethod,
                selectValue: "pickup"
            };
        } else {
            return "Не вибрано";
        }
    }

    const paymentInfo = setPaymentInfo();
    const deliveryInfo = setDeliveryInfo();

    return (
        <div className="order-submit-page">
            <h1>Підтвердження замовлення</h1>
            <StoreInfo />

            <h3>Спосіб оплати</h3>
            <SelectComponent
                img={paymentInfo.img}
                h4Option={paymentInfo.h4}
                pOption={paymentInfo.p}
                selectType={paymentInfo.selectType}
                selectValue={paymentInfo.selectValue}
            />

            <h3>Спосіб доставки</h3>
            <SelectComponent
                img={deliveryInfo.img}
                h4Option={deliveryInfo.h4}
                pOption={deliveryInfo.p}
                selectType={deliveryInfo.selectType}
                selectValue={deliveryInfo.selectValue}
            />

            <div className="total-price">
                <h3>До сплати</h3>
                <p>{totalPrice} ₴</p>
            </div>
            <div className="cart-divider"></div>

            <div className="order-submit__actions">
                <button
                    onClick={handleSubmit}
                    disabled={loading || isTotalPriceLoading}
                    className="order-submit__action_confirm primary_button"
                >
                    {loading ? "Обробка..." : "Підтвердити"}
                </button>

                <button
                    onClick={() => navigate("/cart")}
                    className="primary_button"
                    id="order-submit__action_change"
                >
                    Змінити замовлення
                </button>
            </div>

            {showUnavailableModal && (
                <div className="modal">
                    <div className="modal-content">
                        <h2>Недоступні товари</h2>
                        <p>На жаль, наступні товари більше не доступні:</p>
                        <ul>
                            {unavailableProducts.map((product) => (
                                <li key={product.product_id}>
                                    {product.product_title || product.product_name}
                                </li>
                            ))}
                        </ul>
                        <button onClick={handleCloseModal}>Закрити</button>
                    </div>
                </div>
            )}
            {error && <p className="error-message">{error}</p>}
        </div>
    );
};

export default OrderSubmitPage;